import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Image,
    Transfer,
    message,
    Divider,
    Rate,
    Popover, Form, Col, Popconfirm
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import ReactPlayer from 'react-player'
import {CloseOutlined} from '@ant-design/icons'
import {
    StarOutlined,
    PlusCircleOutlined,
    FormOutlined,
    MobileOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    GlobalOutlined,
    FolderOpenOutlined,
    UserOutlined,
    HistoryOutlined,
    SearchOutlined,
    QrcodeOutlined
} from '@ant-design/icons'
import moment from 'moment';
import weizhi from '../images/weizhi.png';

const {Search} = Input;
const {Option} = Select;
const {RangePicker} = DatePicker;

class DwView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
            visible: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Room/bookView', {
                method: "POST",
                body: JSON.stringify({
                    id: this.props.id,
                })
            })
                .then(res => res.json())
                .then(data => {
                    that.setState({
                        condition: data.data,
                    })
                })
        } else {
            that.setState({
                condition: {},
                loading: false
            })
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.id = that.props.id
        fetch('/Room/book', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }
    sub2() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.id = that.props.id
        fetch('/Room/qxbook', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    render() {

        return (
            <>
                {this.props.type == 1 && <a href='javascript:void(0)'
                                            onClick={this.mdchange.bind(this)}>{this.props.title ? this.props.title : '预订'}</a>}
                {this.props.type == 2 &&
                    <a href='javascript:void(0)' style={{color: '#aaa'}}
                       onClick={this.mdchange.bind(this)}>{this.props.title ? this.props.title : '预订'}</a>}

                <Modal title={this.props.title2} destroyOnClose={true} bodyStyle={{padding: 20}} width={400}
                       visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    {this.props.type == 1 && <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label={<><Space><span>预定天数</span><span
                                        style={{fontSize: 12, color: '#999'}}>(最长不超过14天)</span></Space></>}
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           type={'number'}
                                           min={0}
                                           max={14}
                                           value={this.state.condition.num ? this.state.condition.num : null}
                                           onChange={this.onChange.bind(this, 'num')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item

                                >
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    }
                    {this.props.type == 2 && <div className={'view_box'}>
                        <div className={'view_info'}>
                            <div className={'item'}>
                                <div className={'p1 p1_short'}>预订人</div>
                                <div className={'p2'}>{this.state.condition.aid}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1 p1_short'}>预定时间</div>
                                <div className={'p2'}>{this.state.condition.addtime}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1 p1_short'}>到期时间</div>
                                <div className={'p2'}>{this.state.condition.etime}</div>
                            </div>
                        </div>
                        <Row justify={"center"} style={{width:'100%'}}>
                            <Popconfirm
                                    title="确认取消预定?"
                                    onConfirm={() => this.sub2()}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="primary" loading={this.state.loading}>取消预定</Button>
                                </Popconfirm>
                        </Row>
                    </div>}
                </Modal>
            </>
        )
    }
}

export default DwView
